import {Pinia} from 'pinia'
import {useVerificationApiStore} from '@toolify/client/src/stores/api/VerificationApiStore/useVerificationApiStore'
import {useAuthStore} from '@toolify/client/src/stores/AuthStore/useAuthStore'
import {
  IChangeMailVerificationStrategyInterfaces,
} from '@toolify/server/src/services/VerificationService/strategies/verificationTypeStrategies/ChangeMailVerificationStrategy/types/IChangeMailVerificationStrategyInterfaces'

export function beforeVerifyMailChangeRouterHookFactory(pinia: Pinia) {
  return async function beforeVerifyMailChangeRouterHook(to) {
    const verificationApiStore = useVerificationApiStore(pinia)
    const authStore = useAuthStore(pinia)
    const token = to.params.verificationId as string
    const separatorIndex = token.indexOf('-')
    const verificationId = separatorIndex === -1 ? '' : token.slice(0, separatorIndex)
    const secret = separatorIndex === -1 ? '' : token.slice(separatorIndex + 1)
    if(!verificationId || !secret) {
      to.meta.isVerificationSuccessful = false
      return
    }
    try {
      const {verification} = await verificationApiStore.fulfillVerification<IChangeMailVerificationStrategyInterfaces>(verificationId, secret)
      to.meta.newMail = verification.output.mail
      await authStore.refetchCurrentEntity()
      to.meta.isVerificationSuccessful = true
    } catch {
      to.meta.isVerificationSuccessful = false
    }
  }
}
